import { Injectable }                 from '@angular/core';
import { Response }                   from '@angular/http';
import { FormGroup, FormBuilder,
        Validators, FormControl }     from '@angular/forms';

import { ApiService }                 from '../root-services/api.service';
import { CurrentUserService }         from '../shared/services/current-user.service';
import { Edition }                    from '../models/global/edition';
import { EditionMapData, EditionMap } from './edition-map';

// RxJS Interfaces

import { BehaviorSubject }            from 'rxjs/BehaviorSubject';
import { Observable }                 from 'rxjs/Observable';
import { EditionDetails } from '../models/global/edition-details';

@Injectable()

export class EditionListService {
  private _editions: Observable<Edition[]> = null;
  private _currentEdition: BehaviorSubject<Edition> = new BehaviorSubject<Edition>(null);
  private _editionMap: BehaviorSubject<EditionMap> = new BehaviorSubject<EditionMap>(null);
  private _loading: number = null;
  private editionId: number;

  constructor(private api: ApiService, private currentUser: CurrentUserService) {
    console.log('creating edition service');
  }

  /**
   * Public Methods
   */

  public getEditions(reload?: boolean): Observable<Edition[]> {
    if(this._editions === null || reload) {
      this._editions = this.api.get('/editions')
        .map((response: Response) => response.json() as Edition[])
        .publishReplay(1).refCount()
        .catch(this.handleError);
    }
    return this._editions;
  }

  public waitForEdition(): Observable<Edition> {
    this.currentUser.getUserData().subscribe(user => {
      let editionId = parseInt(localStorage.getItem('edition_id'));

      if(!editionId) {
        editionId = user.default_edition;
        localStorage.setItem('edition_id', editionId.toString());
      }

      if(this._currentEdition.getValue() === null && editionId !== this._loading) {
        this._loading = editionId;
        this.getEditions().subscribe(editions => {
          if(editions.length) {

            let matchingEditions = editions.filter(edition => edition.id === editionId);
            if(matchingEditions.length) {
              let edition = matchingEditions[0];
              this.setCurrentEdition(edition);
            }
          }
        });
      }
    });
    return this._currentEdition.filter(edition => edition !== null);
  }

  public getEditionDetailsObservable(): Observable<EditionDetails> {
    return this.api.get('/edition')
      .map((response: Response) => response.json() as EditionDetails)
      .publishReplay(1).refCount();
  }

  public getEdition(): Edition {
    return this._currentEdition.getValue();
  }

  public getEditionSubject(): BehaviorSubject<Edition> {
    return this._currentEdition;
  }

  public getEditionMap(): EditionMap {
    return this._editionMap.getValue();
  }

  public getEditionMapObservable(): Observable<EditionMap> {
    return this._editionMap;
  }

  public async refreshCurrentEdition(): Promise<void> {
    this._loading = this.editionId;
    let editionId = this.editionId ? this.editionId : +localStorage.getItem('edition_id');
    let response = await this.api.get('/map?edition_id=' + editionId).toPromise();
    let map = new EditionMap(response.json());
    this._editionMap.next(map);
    this._loading = null;
  }

  public setCurrentEdition(edition: Edition) {
    this.editionId = edition.id;
    localStorage.setItem('edition_id', edition.id.toString());
    this.api.get('/map?edition_id=' + edition.id).map(response => response.json()).subscribe(mapData => {
      this._editionMap.next(new EditionMap(mapData));
      this._currentEdition.next(edition);
      this._loading = null;
      this.currentUser.refreshUserData();
    });
  }

  /**
   * Private Methods
   */

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/editions/edition.service.ts